export default {
  data() {
    return {
      weatherDataCont: "",
      loading: false,
      list: [{
        icon: require("../../assets/images/weather/晴.png"),
        name: "06/29",
        temp: "23℃~31℃",
        wind: "南风3~4级"
      }, {
        icon: require("../../assets/images/weather/多云.png"),
        name: "06/30",
        temp: "25℃~31℃",
        wind: "东北风10~14级"
      }, {
        icon: require("../../assets/images/weather/小雨.png"),
        name: "07/01",
        temp: "21℃~27℃",
        wind: "北风2~3级"
      }],
      weatherData: [],
      weatherContent: "",
      chartData: []
    };
  },
  filters: {
    tianqiIconFilter(val) {
      if (val.indexOf("（") > -1) {
        return val.slice(0, val.length - 4);
      }
    }
  },
  computed: {
    tianqiIconComputed() {
      return function (val) {
        if (val.indexOf("（") > -1) {
          return val.slice(0, val.length - 4);
        } else if (val == "轻度雾霾" || val == "中度雾霾" || val == "重度雾霾") {
          return "霾";
        } else if (val == "暴雨") {
          return "大雨";
        } else {
          return val;
        }
      };
    },
    token() {
      return this.$store.state.token;
    }
  },
  // props: {
  //   chartData: {
  //     type: Array,
  //     default: () => []
  //   }
  // },
  mounted() {
    // this.getCaiYunDataByPark();
  },
  watch: {
    token(newVal) {
      this.getCaiYunDataByPark();
    }
  },
  methods: {
    async getCaiYunDataByPark() {
      console.log("取出token开始");
      let data = await this.$api.getCaiYunDataByPark();
      console.log("取出token结束");
      this.chartData = data.splice(0, 3);
      this.weatherContent = this.chartData[0].alertList[0];
    },
    getData() {
      this.loading = true;
      let data = {
        lat: 42.356636,
        lon: 123.632433
      };
      this.$api.getWeatherData(data).then(res => {
        this.loading = false;
        this.weatherDataCont = res.data[res.data.length - 1].alertList[0];
        // this.weatherDataCont = '国家预警信息发布中心:0703预警中-四川省德阳市什邡市-什邡市气象台2022年07月26日09时24分发布高温橙色预警信号：雍城街道、方亭街道、师古镇、南泉镇、马井镇、马祖镇、禾丰镇、湔氐镇、洛水镇未来24小时内最高气温将升至35℃以上。请做好防暑降温工作。';
        // console.log(res)
        this.weatherData = res.data.slice(0, 3);
        this.weatherData.map(i => {
          this.loading = false;
          if (i.skycon.indexOf("（") > -1) {
            i.skycon = i.skycon.slice(0, i.skycon.length - 4);
          }
        });
      });
    }
  }
};